export const SECTION_NAMES = Object.freeze({
  INBOX_STATE: 'INBOX_STATE',
  METADATA_STATE: 'METADATA_STATE',
  OTHER: 'OTHER',
} as const);
